/* eslint-disable import/prefer-default-export */
export enum CampaignSubmissionPhase {
  LOADING = 'LOADING',
  INITIAL = 'INITIAL',
  SUCCESS = 'SUCCESS',
  DUPLICATE = 'DUPLICATE',
  ERROR = 'ERROR',
  INELIGIBLE = 'INELIGIBLE',
  INVALID_LINK = 'INVALID_LINK',
  EXPIRED = 'EXPIRED',
}
